import {
  marketAtom,
  writeMergeLiveItemsAtom,
  writeResetCounterUpAtom,
  writeResetLiveItemsAtom,
  writeSetLiveItemsAtom,
  writeSetMarketVisibilityAtom,
} from "~/_model/market/marketAtom";
import { useAtom, useSetAtom } from "jotai";

export const useMarketStore = () => {
  const [market, setMarket] = useAtom(marketAtom);

  const resetCounterUp = useSetAtom(writeResetCounterUpAtom);
  const resetLiveItems = useSetAtom(writeResetLiveItemsAtom);
  const setLiveItems = useSetAtom(writeSetLiveItemsAtom);
  const mergeLiveItems = useSetAtom(writeMergeLiveItemsAtom);
  const setMarketVisibility = useSetAtom(writeSetMarketVisibilityAtom);

  return {
    market,

    setMarket,
    resetCounterUp,
    resetLiveItems,
    setLiveItems,
    mergeLiveItems,
    setMarketVisibility,
  };
};
